<div
  *ngIf="
    attendanceAndResultSheetInfo && attendanceAndResultSheetInfo.length > 0
  "
>
  <div class="report-header">
    <h5>National Skills Development Authority</h5>
    <h6>Attendance & Result Summary</h6>
    <p>
      <strong>Center Name:</strong>
      {{ attendanceAndResultSheetInfo[0]?.stpName || "" }},
      {{ attendanceAndResultSheetInfo[0]?.districtName || "" }}
    </p>
  </div>

  <div class="row justify-content-center report-meta mb-3">
    <div class="col-auto">
      <strong>Occupation:</strong>
      {{ attendanceAndResultSheetInfo[0]?.name || "" }}
    </div>
    <div class="col-auto">
      <strong>Level:</strong>
      {{ attendanceAndResultSheetInfo[0]?.levelNo || "" }}
    </div>
    <div class="col-auto">
      <strong>Batch ID:</strong>
      {{ attendanceAndResultSheetInfo[0]?.applicationId || "" }}
    </div>
  </div>

  <div class="table-responsive">
    <table
      class="table table-bordered table-sm align-middle text-center modern-table"
    >
      <thead>
        <tr>
          <th scope="col">SL</th>
          <th scope="col">Registration Number</th>
          <th scope="col">Photo</th>
          <th scope="col">Name (English)</th>
          <th scope="col">Name (Bangla)</th>
          <th scope="col">Father's Name (Bangla)</th>
          <th scope="col">Mother's Name (Bangla)</th>
          <th scope="col">Reassessment (Y/N)</th>
          <th scope="col">Mobile No</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of attendanceAndResultSheetInfo; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ row.registrationNo }}</td>
          <td>
            <img
              [src]="safePhotoUrls[i] || 'assets/images/default_report_photo.jpg'"
              alt="{{ row.nameEnglish || row.name }} photo"
              width="60"
              height="60"
              style="
                object-fit: cover;
                border-radius: 4px;
                border: 1px solid #ddd;
              "
            />
          </td>
          <td>{{ row.nameEnglish || row.name }}</td>
          <td>{{ row.nameBangla }}</td>
          <td>{{ row.fatherNameBangla }}</td>
          <td>{{ row.motherNameBangla }}</td>
          <td>{{ row.isReAssessment ? "Yes" : "No" }}</td>
          <td>{{ row.contactNo }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="row justify-content-center report-meta mb-3 signature-meta">
    <!-- Assessor Info -->
    <div class="col-auto">
      <strong>Assessor's Info:</strong>
    </div>
    <div class="col-auto">
      <strong>Name:</strong>
      {{ attendanceAndResultSheetInfo[0]?.assessorName || "" }}
    </div>
    <div class="col-auto">
      <strong>Mobile:</strong>
      {{ attendanceAndResultSheetInfo[0]?.assessorMobileNo || "" }}
    </div>
    <div class="col-auto">
      <strong>Email:</strong>
      {{ attendanceAndResultSheetInfo[0]?.assessorEmail || "" }}
    </div>
    <div class="col-auto">
      <strong>Address:</strong>
      {{ attendanceAndResultSheetInfo[0]?.assessorDistrict || "" }},
      {{ attendanceAndResultSheetInfo[0]?.assessorDivision || "" }}
    </div>
  </div>

  <div class="row justify-content-center report-meta mb-3 signature-meta">
    <!-- NSDA Representative Info -->
    <div class="col-auto">
      <strong>NSDA Representative's Info:</strong>
    </div>
    <div class="col-auto">
      <strong>Name:</strong>
      {{ attendanceAndResultSheetInfo[0]?.representativeOneName || "" }}
    </div>
    <div class="col-auto">
      <strong>Designation:</strong>
      {{ attendanceAndResultSheetInfo[0]?.representativeOneDesignation || "" }}
    </div>
    <div class="col-auto">
      <strong>Mobile No:</strong>
      {{ attendanceAndResultSheetInfo[0]?.representativeOnePhone || "" }}
    </div>
  </div>
</div>
